module.exports = __webpack_public_path__ + "img/img_01@2x.e995f46b.png";